'use strict';

/*
 * The controller RedirectController is used for redirect after new registration
*/

app.controller("RedirectController",['$rootScope', function ($rootScope) {
	window.location.href = $rootScope.config.backend.login_uri;
}]);